/**
 * @generated SignedSource<<2ebc9d9ab1768b538b707b0638df56fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topBar_issueNavigator_projectResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FiltersMenu_project">;
  readonly " $fragmentType": "topBar_issueNavigator_projectResult";
};
export type topBar_issueNavigator_projectResult$key = {
  readonly " $data"?: topBar_issueNavigator_projectResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"topBar_issueNavigator_projectResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraissuenavigatorsavedfiltersmenuenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "topBar_issueNavigator_projectResult",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraissuenavigatorsavedfiltersmenuenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FiltersMenu_project"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b5ea72b10fab20fb0049290dbbcd82e5";

export default node;
